import axios from "axios";
const PREPR_API = process.env.VUE_APP_PREPR_API;
export async function getDigitalUpgradeWhyToBuy() {
  const res = await axios.post(PREPR_API, {
    query: `{
        CommonWhyToBuy (slug: "digital-upgrade-why-to-buy") { 
                heading
                main_description
                main_image { 
                        url
                }
                video
                sub_description
                sub_image { 
                        url
                    }
                    slider_images { 
                            url
                    }
                    general_text
            }
    }`
  });
  return res.data.data.CommonWhyToBuy
}

export async function getDnaTestUpgradeWhyToBuy() {
  const res = await axios.post(PREPR_API, {
    query: `{
        CommonWhyToBuy (slug: "dna-test-why-to-buy") { 
                heading
                main_description
                main_image { 
                        url
                }
                video
                sub_description
                sub_image { 
                        url
                    }
                    slider_images { 
                            url
                    }
                    general_text
            }
    }`
  });
  return res.data.data.CommonWhyToBuy
}

export async function getSupplementUpgradeWhyToBuy() {
  const res = await axios.post(PREPR_API, {
    query: `{
        CommonWhyToBuy (slug: "vitamins-supplement-why-to-buy") { 
                heading
                main_description
                main_image { 
                        url
                }
                video
                sub_description
                sub_image { 
                        url
                    }
                    slider_images { 
                            url
                    }
                    general_text
            }
    }`
  });
  return res.data.data.CommonWhyToBuy
}

export async function getMerchandiseUpgradeWhyToBuy() {
  const res = await axios.post(PREPR_API, {
    query: `{
        CommonWhyToBuy (slug: "digital-upgrade-why-to-buy") { 
                heading
                main_description
                main_image { 
                        url
                }
                video
                sub_description
                sub_image { 
                        url
                    }
                    slider_images { 
                            url
                    }
                    general_text
            }
    }`
  });
  return res.data.data.CommonWhyToBuy
}
